import { StyleSheet, Platform } from 'react-native';
import { AdminColors } from '../../../../../Admin/constants/adminColors';
import FontFamily from '../../../../../../constants/fonts';

const isWeb = Platform.OS === 'web';

const styles = StyleSheet.create({
  // ── Three-lane grid ───────────────────────────────────────────────────
  grid: {
    flexDirection: isWeb ? 'row' : 'column',
    gap: 12,
  },

  // ── Individual lane card ──────────────────────────────────────────────
  lane: {
    flex: isWeb ? 1 : undefined,
    borderRadius: 6,
    borderWidth: 1,
    overflow: 'hidden',
  },
  laneGood:    { borderColor: '#2D9E52' },   // green border
  laneImprove: { borderColor: '#E8A020' },   // amber border
  laneKeep:    { borderColor: '#5B8DC9' },   // blue border

  // ── Lane header block ─────────────────────────────────────────────────
  laneHeader: {
    paddingHorizontal: 12,
    paddingTop: 12,
    paddingBottom: 8,
    gap: 4,
  },
  laneHeaderGood:    { backgroundColor: '#EBF7EE' },
  laneHeaderImprove: { backgroundColor: '#FEF7E6' },
  laneHeaderKeep:    { backgroundColor: '#EBF2FA' },

  // ── Pill tag ─────────────────────────────────────────────────────────
  // Matches the HTML `.people-feedback-tag` — small uppercase rounded pill
  pillTag: {
    alignSelf: 'flex-start',
    borderRadius: 4,
    paddingHorizontal: 7,
    paddingVertical: 2,
    marginBottom: 4,
  },
  pillTagGood:    { backgroundColor: '#C3EDCC' },
  pillTagImprove: { backgroundColor: '#FAE3AA' },
  pillTagKeep:    { backgroundColor: '#BFDBF7' },
  pillTagText: {
    fontFamily: FontFamily.bold,
    fontSize: 10,
    textTransform: 'uppercase',
    letterSpacing: 0.8,
  },
  pillTagTextGood:    { color: '#166534' },
  pillTagTextImprove: { color: '#92400E' },
  pillTagTextKeep:    { color: '#1E40AF' },

  // ── Lane title & hint ────────────────────────────────────────────────
  laneTitle: {
    fontFamily: FontFamily.bold,
    fontSize: isWeb ? 14 : 13,
    color: AdminColors.textPrimary,
  },
  laneHint: {
    fontFamily: FontFamily.regular,
    fontSize: 12,
    color: AdminColors.textSecondary,
  },

  // ── Textarea — plain border, no lane color bleed ──────────────────────
  textArea: {
    margin: 10,
    minHeight: isWeb ? 100 : 88,
    borderWidth: 1,
    borderColor: AdminColors.borderDefault,
    borderRadius: 4,
    padding: 8,
    backgroundColor: AdminColors.bgSurface,
    color: AdminColors.textPrimary,
    fontFamily: FontFamily.regular,
    fontSize: isWeb ? 13 : 12,
    textAlignVertical: 'top',
  },
  textAreaFocused: {
    borderColor: AdminColors.blue700,
  },

  // ── Read-only display ─────────────────────────────────────────────────
  readOnlyText: {
    margin: 12,
    fontFamily: FontFamily.regular,
    fontSize: isWeb ? 13 : 12,
    color: AdminColors.textPrimary,
    lineHeight: 19,
  },
  readOnlyEmpty: {
    color: AdminColors.textMuted,
    fontStyle: 'italic',
  },
});

export default styles;
